import React, { useEffect } from "react";

// Asks before a conversation is deleted. Escape and a click on the backdrop
// both cancel.
export function DeleteConfirmModal({ language, onConfirm, onCancel }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onCancel();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onCancel]);

  return (
    <div
      className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-fadeIn"
      onClick={onCancel}
    >
      <div
        className="bg-white dark:bg-gray-800 rounded-2xl p-6 max-w-md w-full shadow-2xl border border-gray-200 dark:border-gray-700 animate-scaleIn"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-4 mb-4">
          <div className="w-12 h-12 flex-shrink-0 bg-red-100 dark:bg-red-500/15 rounded-full flex items-center justify-center">
            <svg
              className="w-6 h-6 text-red-600 dark:text-red-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
            {language === "zh" ? "確認刪除" : "Confirm Delete"}
          </h3>
        </div>
        <p className="text-sm text-gray-600 dark:text-gray-300 mb-6">
          {language === "zh"
            ? "您確定要刪除這個對話記錄嗎？此操作無法撤銷。"
            : "Are you sure you want to delete this conversation? This action cannot be undone."}
        </p>
        <div className="flex gap-3 justify-end">
          <button
            className="px-4 py-2 rounded-lg text-gray-700 dark:text-gray-200 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors font-medium text-sm"
            onClick={onCancel}
          >
            {language === "zh" ? "取消" : "Cancel"}
          </button>
          <button
            className="px-4 py-2 rounded-lg text-white bg-red-600 hover:bg-red-700 transition-colors font-medium text-sm shadow-sm"
            onClick={onConfirm}
          >
            {language === "zh" ? "刪除" : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
}
